module.exports = __webpack_public_path__ + "img/lim guan eng.f0c156a1.jpg";